import React, { useState } from "react";
import { CSS_CLASSES } from "../../../css-classes";
import HoverNav from "./hover/HoverNav";
import { useSelector } from "react-redux";
import PropTypes from "prop-types";
import { withTranslation } from "react-i18next";
import Popup from "../../../components/popup/Popup";
import NavbarInner from "./reusable-nav-component/NavbarInner";

const Navbar = (props) => {

  const { componentSetting } = useSelector((state) => ({
    componentSetting: state.componentSettingListR.data,
  }));

  const [hovered, setHovered] = useState(false);
  const [isComingSoon, setComingSoon] = useState(false);
  const [isItem, setIsItem] = useState();

  const handleOver = () => {
    setHovered(true);
  };
  const handleOut = () => {
    setHovered(false);
  };

  const mouseOver = (code) => {
    setIsItem(code);
  };


  const handlePopup = () => {
    setComingSoon(false);
  };
  const handlePopupClose = () => {
    setComingSoon(true);
  };

  return (
    <div className={hovered ? "hover pos-r" : "pos-r"} onMouseOver={handleOver} onMouseLeave={handleOut}    >
      <div className="container">
        <div className={componentSetting?.["horizonatal-nav-bar"]?.["default-value"]}        >
          <ul className={CSS_CLASSES.navbar}>
            <NavbarInner navCarousel={false} mouseOver={mouseOver} handlePopupClose={handlePopupClose} />
          </ul>
        </div>
      </div>
      <HoverNav code={isItem} />
      {isComingSoon && <Popup handlePoup={handlePopup} comingSoon />}
    </div >
  );
};
Navbar.propTypes = {
  preGlobalFilteredRows: PropTypes.any,
};
export default withTranslation()(Navbar);
